import(/* webpackMode: "eager" */ "/tmp/8ded6b2b577299b/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/tmp/8ded6b2b577299b/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/tmp/8ded6b2b577299b/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8ded6b2b577299b/src/components/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8ded6b2b577299b/src/components/ui/ShareButtons.tsx");
